import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (req) =>
    present(
      repository
        .updatePlanzoneContacts(req.planzone, req.nextContacts)
        .then(() => req)
        .catch(() => Promise.reject(req)),
    );
}

export type { Interactor };

export { createInteractor };
